/** @shell standard @header bar */
import React, { useEffect, useMemo } from 'react';
import { View } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';

import { ScreenHeader, useScreenHeaderScroll } from '../components/common/ScreenHeader';
import { appTheme, useThemeColors } from '../shared/theme';
import { useTranslation } from '../shared/i18n';
import { useExitOrGoBack } from '../shared/navigation/useAuthNavigation';
import { HealthInformationScrollBody } from './components/HealthInformationScrollBody';
import { useHealthInformationCms } from './components/HealthInformationCmsContext';
import { androidAppHeaderContentTop } from '../shared/theme/sharedStyles';
import {
  StackScreenShell,
  STACK_SCROLL_GUTTER,
  STACK_SECTION_GAP,
} from '../shared/theme/studio/stackScreenShell';

import { createHealthInformationSourcesStyles } from './components/healthInformationSharedStyles';

export const HealthInformationSourcesScreen: React.FC = () => {
  const on_back_exit = useExitOrGoBack();
  const { t } = useTranslation();
  const insets = useSafeAreaInsets();
  const colors = useThemeColors() ?? appTheme.colors;
  const styles = useMemo(() => createHealthInformationSourcesStyles(colors), [colors]);
  const content_top = androidAppHeaderContentTop(insets.top, appTheme.spacing.sm);
  const { isLoading, isAvailable, pageTitle } = useHealthInformationCms();
  const { scrollY } = useScreenHeaderScroll();
  const header_title = pageTitle || t('healthInformation.title');

  useEffect(() => {
    if (!isLoading && !isAvailable) {
      on_back_exit();
    }
  }, [isAvailable, isLoading, on_back_exit]);

  if (!isLoading && !isAvailable) {
    return null;
  }

  return (
    <StackScreenShell colors={colors}>
      <ScreenHeader title={header_title} onBack={on_back_exit} scrollY={scrollY} />

      <View
        style={[
          styles.scroll,
          {
            paddingHorizontal: STACK_SCROLL_GUTTER,
            paddingTop: content_top,
            paddingBottom: insets.bottom + STACK_SECTION_GAP * 2,
            flex: 1,
            minHeight: 0,
          },
        ]}>
        <HealthInformationScrollBody />
      </View>
    </StackScreenShell>
  );
};
